export function applyButton() {
    var applyButtons = document.querySelectorAll(".cx2_vacancydetails-apply");
    applyButtons.forEach(function(button) {
        button.classList.add("btn");
        button.classList.add("btn--primary");
        button.textContent = "Solliciteer direct";
    });
}
